import { Outlet, useLocation } from 'react-router-dom'

import { Tabs } from '../../../../common/designs'
import { useAppSelector, useDashboard, useEnhancedNavigate } from '../../../../common/hooks'
import { selectIsTaskFeaturesEnabled } from '../../processesSlice'
import { AnalysisRouteTitles, AnalysisRoutes } from './constants'

const NAV_OPTIONS = [
  { label: AnalysisRouteTitles.STEPS, value: AnalysisRoutes.STEPS },
  { label: AnalysisRouteTitles.TEAMS, value: AnalysisRoutes.TEAMS },
  { label: AnalysisRouteTitles.TRANSACTIONS, value: AnalysisRoutes.TRANSACTIONS },
  { label: AnalysisRouteTitles.CUSTOM, value: AnalysisRoutes.CUSTOM },
]

const NAV_OPTIONS_WITHOUT_TASK_DATA = [
  { label: AnalysisRouteTitles.STEPS, value: AnalysisRoutes.STEPS },
  { label: AnalysisRouteTitles.TRANSACTIONS, value: AnalysisRoutes.TRANSACTIONS },
]

const NAV_OPTIONS_WITHOUT_TASK_DATA_PRO = [
  { label: AnalysisRouteTitles.STEPS, value: AnalysisRoutes.STEPS },
  { label: AnalysisRouteTitles.TRANSACTIONS, value: AnalysisRoutes.TRANSACTIONS },
  { label: AnalysisRouteTitles.CUSTOM, value: AnalysisRoutes.CUSTOM },
]

export const SecondLayerAnalysisLayout = () => {
  const location = useLocation()
  const { enhancedNavigate: navigate } = useEnhancedNavigate()
  const isTaskFeaturesEnabled = useAppSelector(selectIsTaskFeaturesEnabled)
  const {
    user: { isPlatformViewer },
  } = useDashboard()

  let navTabs = NAV_OPTIONS
  if (!isTaskFeaturesEnabled) {
    navTabs = isPlatformViewer ? NAV_OPTIONS_WITHOUT_TASK_DATA : NAV_OPTIONS_WITHOUT_TASK_DATA_PRO
  }
  let dimension = location.pathname.split('analysis').pop()
  dimension = dimension && dimension[0] === '/' ? dimension.substring(1) : dimension

  const onTabSelected = (val: string) => {
    navigate(`./${val}`)
  }

  return (
    <div className='flex flex-col gap-3'>
      <Tabs size='s' options={navTabs} value={dimension || ''} onChange={onTabSelected} />
      <Outlet />
    </div>
  )
}

export default SecondLayerAnalysisLayout
